// DTM
import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  padding: 206px 0 77px 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1100px) {
    padding: 111px 0 52px 0;
  }
  @media (max-width: 700px) {
    padding: 93px 0 39px 0;
  }
`;
const Title = styled.div`
  position: absolute;
  top: 92px;
  left: calc(50% - 520px);

  height: 58px;
  font-family: Lato;
  font-size: 42px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: 0.6px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    left: 25px;
    top: 17px;

    height: 58px;
    font-size: 27px;
    line-height: 2.15;
    letter-spacing: 0.4px;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    left: 23px;
    top: 35px;

    height: 31px;
    font-size: 23px;
    line-height: 1.35;
    letter-spacing: 0.3px;
  }
`;
const Inner = styled.div`
  width: 1050px;
  border-top: solid 0.5px #e5e5e5;
  border-left: solid 0.5px #e5e5e5;
  border-top: solid 1px #efefef;
  border-left: solid 1px #efefef;
  display: grid;
  justify-items: stretch;
  grid-template-columns: auto auto auto auto auto auto auto;
  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    margin: 0 25px;
  }
  @media (max-width: 1025px) {
    grid-template-columns: auto auto auto auto auto auto;
  }
  @media (max-width: 890px) {
    grid-template-columns: auto auto auto auto auto;
  }
  @media (max-width: 750px) {
    grid-template-columns: auto auto auto auto;
  }
  @media (max-width: 610px) {
    grid-template-columns: auto auto auto;
  }
  @media (max-width: 470px) {
    grid-template-columns: auto auto;
  }
  @media (max-width: 310px) {
    grid-template-columns: auto;
  }
`;
const Cat = styled.a`
  height: 149px;
  border-right: solid 0.5px #e5e5e5;
  border-bottom: solid 0.5px #e5e5e5;
  border-right: solid 1px #efefef;
  border-bottom: solid 1px #efefef;
  float: left;
  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const CatImage = styled.img`
  width: 99px;
  height: 99px;

  margin-top: 6px;
  left: calc(50% - 49px);
`;
const CatTitleContainer = styled.div`
  position: absolute;
  top: 112px;
  height: 30px;
  width: calc(100% - 14px);
  padding: 0 7px;
`;
const CatTitle = styled.div`
  opacity: 0.7;
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: center;
  color: #000000;
`;

class Categories extends Component {
  render() {
    let items = [];
    let auctionBaseUrl = "/portal";
    if (
      this.props.auction &&
      this.props.auctions &&
      this.props.auctions[this.props.auction] &&
      this.props.auctions[this.props.auction].url &&
      this.props.categories &&
      this.props.categories[this.props.auction]
    ) {
      for (var i in this.props.categories[this.props.auction]) {
        items.push(this.props.categories[this.props.auction][i]);
      }
      auctionBaseUrl = this.props.auctions[this.props.auction].url;
    }
    if (items.length > 0 && items.length > 1) {
      items = items.sort(
        (a, b) => a.weight - b.weight || a.title.localeCompare(b.title)
      );
    }
    return (
      <Wrapper>
        <Title>Ons aanbod</Title>
        <Inner>
          {items.map(cat => (
            <Cat
              key={cat.id}
              href={auctionBaseUrl + "/auction?categories=" + cat.id}
            >
              {cat.image && cat.image.small ? (
                <CatImage src={auctionBaseUrl + "/" + cat.image.small} />
              ) : null}
              <CatTitleContainer>
                <CatTitle>{cat.title}</CatTitle>
              </CatTitleContainer>
            </Cat>
          ))}
        </Inner>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    auction: state.auction.data,
    auctions: state.auctions.data,
    categories: state.categories.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTodoClick: id => {
      dispatch({ type: "NONE" });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Categories);



// WEBPACK FOOTER //
// ./src/components/Categories.js